/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_AmountInputs */

const en__field_amount = /** @type {(inputs: _Field_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount (Cents)`)
};

const de__field_amount = /** @type {(inputs: _Field_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrag (Cents)`)
};

/**
* | output |
* | --- |
* | "Amount (Cents)" |
*
* @param {_Field_AmountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_amount = /** @type {((inputs?: _Field_AmountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_AmountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_amount(inputs)
	return de__field_amount(inputs)
});